// removed by extract-text-webpack-plugin
module.exports = {"main":"_1sc2r_EM2I1AGMxBWq-jSb"};


//////////////////
// WEBPACK FOOTER
// ./components/Receipt.module.css
// module id = 2363
// module chunks = 1